import type { BBox } from "@shared/types";

export function bboxFromCenter(
  lat: number,
  lon: number,
  spanLat = 0.06,
  spanLon = 0.1,
): BBox {
  return {
    top: lat + spanLat / 2,
    bottom: lat - spanLat / 2,
    left: lon - spanLon / 2,
    right: lon + spanLon / 2,
  };
}

export function bboxKey(b: BBox): string {
  return `${b.top.toFixed(4)}|${b.bottom.toFixed(4)}|${b.left.toFixed(4)}|${b.right.toFixed(4)}`;
}

export function metersBetween(
  a: { lat: number; lon: number },
  b: { lat: number; lon: number },
): number {
  const R = 6_371_000;
  const toRad = (x: number) => (x * Math.PI) / 180;
  const dLat = toRad(b.lat - a.lat);
  const dLon = toRad(b.lon - a.lon);
  const lat1 = toRad(a.lat);
  const lat2 = toRad(b.lat);
  const sa =
    Math.sin(dLat / 2) ** 2 +
    Math.sin(dLon / 2) ** 2 * Math.cos(lat1) * Math.cos(lat2);
  return 2 * R * Math.asin(Math.sqrt(sa));
}
